import {
  FETCH_PAYMENT_SERVICE_CHARGES_SUCCESS,
  FETCH_PAYMENT_SERVICE_CHARGES_FAILURE,
} from '../../actions/school'

const initialState = {
  serviceCharges: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENT_SERVICE_CHARGES_SUCCESS:
      return {
        ...state,
        serviceCharges: action.serviceCharges.reduce(
          (paymentServiceCharges, paymentServiceCharge) => {
            Object.assign(paymentServiceCharges, {
              [paymentServiceCharge.payment_method]: paymentServiceCharge,
            })
            return paymentServiceCharges
          },
          {},
        ),
      }
    case FETCH_PAYMENT_SERVICE_CHARGES_FAILURE:
      return {
        ...state,
        serviceCharges: [],
      }
    default:
      return state
  }
}

export const getPaymentServiceCharges = (state) => {
  return state.school.serviceCharges
}
